export const clientsEndpoints = {
  getAssetsDropdown: "/dropdown",
  getCoverageStateList: "/client/coverage/states",
  getCitiesByState: "client/coverage/cities",
  updateCoverage: "/coverage",
  clientAssetDropdown:
    "/dropdown?type=LookupTypes&field=label&field=value&filterBy=type&filterValue=",
  clientAssetLocationDropdown: `/dropdown?type=ClientLocations&field=id&filterBy=clientId&filterValue`,
  createAsset: "/client/assets",
  bulkCreateClients: "/client/basic-info/bulk",
  clientOnboarding: "/client/onboarding-stage",
  getClientSummary: "/client/summary",
  dropdown: "/dropdown",
  paymentInvoicing: "/client/payment-invoicing",
  onboardingStage: "/client/onboarding-stage",
  checkInOut: "/client/check-in-out",
  getBrands: "/client/brands",
  brandCatalog: "/client/brands-catalog",
  clientDropdown: "/dropdown",
  fuzzyMatchCities: "/client/coverage/map-settings",
  getClientOverview: "/client/overview",
  clientCoverageList: "/client/coverage/list",
  getClientHeader: "/client/header",
  updateBrandName: "/client/brands",
  getClientNotes: "/client/note",
  createOrUpdateClientNote: "/client/note",
  deleteClientNote: "/client/note",
  previewCoverage: (sourceId: string, coordinates: number[][][]) => {
    return `states/${sourceId}/preview?coordinates=${encodeURIComponent(JSON.stringify(coordinates))}`;
  },
  coordinatesCoverage: (clientId: string, coordinates: number[][][]) => {
    return `states/${clientId}/coordinates?coordinates=${encodeURIComponent(JSON.stringify(coordinates))}`;
  },
};
